import { Button } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { DatePicker } from "antd";
import DrawerFilter from "components/DrawerFilter/DrawerFilter";
import FilterIcon from "components/icons/FilterIcon";
import LoadingComponent from "components/loading/Loading";
import {
  fetchStatisticFarms,
  selectFilterStatisticFarm,
  selectLoading,
  selectStatisticFarm,
  setFilterStatisticFarm,
} from "features/Admin/adminSlice";
import moment from "moment";
import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { checkOddAndFixed } from "util/checkOdd";
import ChartStatisticFarm from "./chartStatisticFarm/ChartStatisticFarm";
import { toast } from "react-toastify";
import FileDownload from "js-file-download";
import { BASE_URL, TOKEN } from "constants/config";
import { buildApiUrl } from "api/farmApi";
import axios from "axios";

const useStyles = makeStyles({
  table: {
    minWidth: 700,
    overflowX: "auto",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 12,
  },
  tabs: {
    display: "flex",
  },
  tabItem: {
    padding: 8,
    borderRadius: 6,
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    color: "#000",
    background: "#ECEDF2",
    marginRight: 4,
    minWidth: 120,
    cursor: "pointer",
  },
  active: {
    background: "#4350B0",
    color: "#fff",
  },
  stickyCol: {
    position: "sticky",
    left: 0,
    background: "#ECEDF2",
    zIndex: 800,
    fontWeight: "bold",
  },
  filter: {
    display: "flex",
    alignItems: "center",
    gap: "0px 12px",
  },
  filterIcon: {
    cursor: "pointer",
  },
  btn_export: {
    background: "#F65C00",
    color: "#fff",
    borderRadius: 6,
    textTransform: "capitalize",
    "&:hover": {
      background: "#F65C00",
      opacity: 0.8,
    },
  },
});

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#eaedf4",
    color: theme.palette.common.black,
    borderRight: "1px solid rgba(224, 224, 224, 1)",
    minWidth: 125,
  },
  body: {
    fontSize: 14,
    borderRight: "1px solid rgba(224, 224, 224, 1)",
  },
}))(TableCell);

export default function TotalFarm() {
  const classes = useStyles();
  const tabs = [
    {
      name: "Thống kê",
      active: true,
    },
    {
      name: "Biểu đồ",
      active: false,
    },
  ];
  const [activeTab, setActiveTab] = useState(tabs);
  const [openDrawerFilter, setOpenDrawerFilter] = useState(false);
  const listStatisticFarm = useSelector(selectStatisticFarm);
  const filter = useSelector(selectFilterStatisticFarm);
  const loading = useSelector(selectLoading);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchStatisticFarms(filter));
  }, [dispatch, filter]);

  const handleChangeTab = (name) => {
    const mappingActive = activeTab.map((tab) => {
      if (tab.name == name) {
        return {
          ...tab,
          active: true,
        };
      }
      return {
        ...tab,
        active: false,
      };
    });
    setActiveTab(mappingActive);
  };
  const onFilterDate = (date, dateString) => {
    dispatch(
      setFilterStatisticFarm({
        ...filter,
        year: Number(dateString),
      })
    );
  };

  const onExportFile = async () => {
    const token = localStorage.getItem(TOKEN);
    try {
      const res = await axios({
        method: "GET",
        url: buildApiUrl(`${BASE_URL}/statisic/farms/export/excel`,filter),
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "blob",
        },
        responseType: "arraybuffer",
      });
      if (res.data.responseDescription) {
        toast.error('Xuất file thất bại');
        return;
      }
      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      FileDownload(blob, `report-repeatation-${new Date().getTime()}.xlsx`);
      toast.success('Xuất file thành công');
    } catch (error) {}
  };


  const onOpenFilterDrawer = () => {
    setOpenDrawerFilter(true);
  };

  const getFarmCount = (data, name) => {
    const filterData = data.find((item) => item.name === name);
    return Number(filterData.farmCount);
  };
  const getFarmAvgMark = (data, name) => {
    const filterData = data.find((item) => item.name === name);
    return checkOddAndFixed(Number(filterData.farmAvgMark));
  };

  const onFilter = (data) => {
    dispatch(
      setFilterStatisticFarm({
        ...filter,
        region: data.region,
        province: data.province,
      })
    );
    setOpenDrawerFilter(false);
  };

  return (
    <div>
      <div className={classes.header}>
        <div className={classes.tabs}>
          {activeTab?.map((tab) => (
            <div
              onClick={() => handleChangeTab(tab.name)}
              key={tab.name}
              className={
                tab.active
                  ? `${classes.tabItem} ${classes.active}`
                  : classes.tabItem
              }
            >
              {tab.name}
            </div>
          ))}
        </div>

        <div className={classes.filter}>
          <div className={classes.filterIcon} onClick={onOpenFilterDrawer}>
            <FilterIcon></FilterIcon>
          </div>
          <DatePicker
            onChange={onFilterDate}
            picker="year"
            defaultValue={moment()}
          />
          <Button
            onClick={onExportFile}
            className={classes.btn_export}
            variant="contained"
            color="primary"
          >
            Xuất File
          </Button>
        </div>
      </div>
      {activeTab[0].active &&
        (loading ? (
          <LoadingComponent />
        ) : (
          <TableContainer component={Paper}>
            <Table
              stickyHeader
              className={classes.table}
              aria-label="spanning table"
            >
              <TableHead>
                <TableRow>
                  <StyledTableCell
                    className={classes.stickyCol}
                  ></StyledTableCell>
                  {listStatisticFarm?.map((farm) => (
                    <StyledTableCell
                      colSpan={2}
                      key={Math.random() * 100}
                      align="center"
                      style={{ fontWeight: "bold" }}
                    >
                      Tháng {farm.month}
                    </StyledTableCell>
                  ))}
                </TableRow>
                <TableRow>
                  <StyledTableCell
                    className={classes.stickyCol}
                    style={{ background: "#ECEDF2" }}
                  ></StyledTableCell>
                  {listStatisticFarm.map((farm, idx) => (
                    <Fragment key={Math.random() * 100}>
                      <StyledTableCell
                        align="center"
                        style={{ background: "#ECEDF280" }}
                      >
                        Số lượng trại
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        style={{ background: "#ECEDF280" }}
                      >
                        Điểm TB
                      </StyledTableCell>
                    </Fragment>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {listStatisticFarm[0]?.statisticFarms?.map((row) => (
                  <TableRow key={Math.random() * 100}>
                    <StyledTableCell
                      className={classes.stickyCol}
                      style={{ background: "#FFF", color: "#4350B0" }}
                    >
                      {row.name}
                    </StyledTableCell>
                    {listStatisticFarm.map((farm) => (
                      <Fragment key={Math.random() * 100}>
                        <StyledTableCell align="center">
                          {getFarmCount(farm.statisticFarms, row.name)}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {getFarmAvgMark(farm.statisticFarms, row.name)}
                        </StyledTableCell>
                      </Fragment>
                    ))}
                  </TableRow>
                ))}

                <TableRow>
                  <StyledTableCell
                    className={classes.stickyCol}
                    style={{ background: "#FFF", color: "#4350B0" }}
                  >
                    Tổng trại
                  </StyledTableCell>
                  {listStatisticFarm.map((item) => (
                    <Fragment key={Math.random() * 100}>
                      <StyledTableCell align="center">
                        {Number(item.totalAllFarm)}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {Number(item.markAllFarm)}
                      </StyledTableCell>
                    </Fragment>
                  ))}
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        ))}
      {activeTab[1].active && (
        <ChartStatisticFarm listStatisticFarm={listStatisticFarm} />
      )}
      {openDrawerFilter && (
        <DrawerFilter
          onClose={() => setOpenDrawerFilter(false)}
          open={openDrawerFilter}
          onSubmit={onFilter}
          filter={filter}
        />
      )}
    </div>
  );
}
